import React from 'react';
import { Box, FormControlLabel, Switch, TextField } from '@mui/material';
import { styles } from './PageFootNotes.styles';
import { ISetupPdfMessages } from '../../../../../../types/setupPDFTypes';
import { IExportPdfOptionsState } from '../../StorySetupPDFView';

export type PageFootNotesProps = {
  messages: ISetupPdfMessages;
  exportPdfOptions: IExportPdfOptionsState;
  setExportPdfOptions: (exportPdfOptions: IExportPdfOptionsState) => void;
};
const PageFootNotes: React.FC<PageFootNotesProps> = ({ messages, exportPdfOptions, setExportPdfOptions }) => {
  const handlePageFootNotesChange = (value: boolean, key: string) => {
    setExportPdfOptions({ ...exportPdfOptions, [key]: value });
  };

  return (
    <>
      <FormControlLabel
        sx={styles.switchControlLabel}
        control={<Switch size="small" />}
        label={messages.storyTitle}
        labelPlacement="start"
        checked={exportPdfOptions.displayTitle}
        onChange={(_, checked) => handlePageFootNotesChange(checked, 'displayTitle')}
      />
      <FormControlLabel
        sx={styles.switchControlLabel}
        control={<Switch size="small" />}
        label={messages.dateOfExport}
        labelPlacement="start"
        checked={exportPdfOptions.displayDate}
        onChange={(_, checked) => handlePageFootNotesChange(checked, 'displayDate')}
      />
      <FormControlLabel
        sx={styles.switchControlLabel}
        control={<Switch size="small" />}
        label={messages.pageNumber}
        labelPlacement="start"
        checked={exportPdfOptions.displayPageNumber}
        onChange={(_, checked) => handlePageFootNotesChange(checked, 'displayPageNumber')}
      />
      {exportPdfOptions.displayPageNumber ? (
        <Box sx={styles.startingPageNumberContainer}>
          <TextField
            type="number"
            label={messages.startingPageNumber}
            value={exportPdfOptions.startingPage}
            onChange={(e) => setExportPdfOptions({ ...exportPdfOptions, startingPage: parseInt(e.target.value) })}
            inputProps={{
              min: 1
            }}
          />
        </Box>
      ) : null}
    </>
  );
};

export default PageFootNotes;
